import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckCircle2Icon, LockIcon } from 'lucide-react';
const items = [{
  label: 'Protocolo SOS Completo (4 Capítulos)',
  value: '$47'
}, {
  label: 'Checklists y Hojas de Trabajo Interactivas',
  value: '$17'
}, {
  label: 'Guía de Suplementos con Marcas en USA',
  value: '$27'
}, {
  label: 'Directorio de Recursos y Cobertura Medicare',
  value: '$17'
}];
export function PricingSection() {
  return <section id="pricing" className="py-20 lg:py-28 bg-cream" data-id="element-80">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-82">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal mb-3" data-id="element-83">
            Invierte en Tus Pies Hoy
          </h2>
          <p className="text-lg sm:text-xl font-body text-gray-600" data-id="element-84">
            Una visita a urgencias cuesta miles. Prevenirlo cuesta menos que una
            cena.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-gold-brand" data-id="element-85">
          <div className="bg-danger text-white text-center py-3 font-bold tracking-wide uppercase text-sm font-body" data-id="element-86">
            ⏰ Precio Especial por Tiempo Limitado
          </div>

          <div className="p-7 sm:p-10" data-id="element-87">
            <h3 className="text-xl font-heading font-bold text-emerald-dark mb-6 border-b pb-4" data-id="element-88">
              Lo que obtienes hoy con acceso inmediato:
            </h3>

            <ul className="space-y-4 mb-8" data-id="element-89">
              {items.map((item, i) => <li key={i} className="flex items-center justify-between text-base sm:text-lg font-body text-charcoal" data-id="element-90">
                  <span className="flex items-center gap-2.5" data-id="element-91">
                    <CheckCircle2Icon className="w-5 h-5 text-emerald-brand flex-shrink-0" data-id="element-92" />
                    {item.label}
                  </span>
                  <span className="text-gray-400 line-through ml-3 flex-shrink-0" data-id="element-93">
                    {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="border-t border-gray-200 pt-6 mb-8 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-94">
              <div className="space-y-1" data-id="element-95">
                <span className="text-lg font-bold text-gray-400 font-body" data-id="element-96">
                  Valor Total: <span className="line-through" data-id="element-97">$108</span>
                </span>
              </div>
              <div className="text-center sm:text-right" data-id="element-98">
                <span className="block text-base text-emerald-dark font-bold font-body" data-id="element-99">
                  Tu Precio Hoy:
                </span>
                <span className="text-2xl sm:text-3xl font-heading font-bold text-gray-400 line-through" data-id="element-100">
                  $27
                </span>
                <div className="flex items-center justify-center sm:justify-end gap-3 mt-1" data-id="element-101">
                  <span className="text-5xl sm:text-6xl font-heading font-bold text-emerald-brand" data-id="element-102">
                    $6.39
                  </span>
                  <span className="bg-danger text-white text-xs sm:text-sm font-bold font-body px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-103">
                    -76% OFF
                  </span>
                </div>
              </div>
            </div>

            <a href="https://info-marketingdigital.com/cart/52889148752188:1" target="_blank" rel="noopener noreferrer" className="w-full bg-emerald-brand hover:bg-emerald-dark text-white font-bold text-xl sm:text-2xl py-5 px-4 rounded-xl shadow-xl transition-all hover:scale-[1.02] flex flex-col items-center gap-1 no-underline" data-id="element-104">
              <span data-id="element-105">¡SÍ! Quiero Proteger Mis Pies</span>
              <span className="text-sm font-normal text-emerald-light/80" data-id="element-106">
                Descargar Ahora por Solo $6.39
              </span>
            </a>

            <div className="mt-6 space-y-4 flex flex-col items-center" data-id="element-107">
              <div className="flex items-center gap-2 text-gray-400 text-sm font-body" data-id="element-108">
                <LockIcon className="w-4 h-4" data-id="element-109" />
                <span data-id="element-110">Pago 100% Seguro y Encriptado</span>
              </div>
              <div className="flex items-center gap-4 bg-emerald-light/50 p-4 rounded-xl border border-emerald-brand/15 w-full" data-id="element-111">
                <ShieldCheckIcon className="w-9 h-9 text-gold-brand flex-shrink-0" data-id="element-112" />
                <div className="text-left" data-id="element-113">
                  <p className="font-bold text-charcoal font-body" data-id="element-114">
                    Garantía de Satisfacción de 30 Días
                  </p>
                  <p className="text-sm text-gray-600 font-body" data-id="element-115">
                    Si no sientes alivio, te devolvemos tu dinero. Sin
                    preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}